import { useIntl } from '@atlassian/jira-intl';
import { useCustomSkipLink } from '@atlassian/jira-navigation-system';
import messages from './messages';

export const JiraHomeSidePanelSkipLink = () => {
	const { formatMessage } = useIntl();

	useCustomSkipLink('jira-home-side-panel', formatMessage(messages.skipToRightSidePanel), 4);

	return null;
};
